import { createContext } from "react";

const AppContext = createContext({
  categories: [],
  setCategories: () => {},
  subCategories: [],
  setSubCategories: () => {},
  level3Categories: [],
  setLevel3Categories: () => {},
  otherCategories: [],
  setOtherCategories: () => {},
  cartLength: "",
  setCartLength: () => {},
  cartVersion: 0,
  bumpCartVersion: () => {},
  showPrice: undefined,
  setShowPrice: () => {},
});

export default AppContext;
